export type ErrorPattern = {
    regex: RegExp;
    key: string;
    placeholders: string[];
};

export const errorPatterns: ErrorPattern[] = [
    {
        regex: /Duplicate entry '(.*?)' for key '(.*?)'/,
        key: "Duplicate entry",
        placeholders: ["value", "column"]
    }
];
